export default "__VITE_ASSET__B9q4HtcG__"